import { useMutation, useQueryClient } from 'react-query'
import FilesAndDirectoriesService from '../../../services/FilesAndDirectoriesService'
import { useParams } from 'react-router-dom'

type DuplicatePayload = {
  organization: string
  selectedProjects: string[]
}
export const useItemBulkDuplicate = (directoryPath?: string) => {
  const queryClient = useQueryClient()
  const { org, project } = useParams()

  return useMutation<any, Error, DuplicatePayload>({
    mutationKey: ['bulk-duplicate-items'],
    mutationFn: async ({ organization, selectedProjects }) => {
      await Promise.all(
        selectedProjects.map((name) =>
          FilesAndDirectoriesService.duplicate(
            organization,
            `${project}/${directoryPath ? `${directoryPath}/` : ''}${name}`,
            name.includes('.') ? 'files' : 'directories',
          ),
        ),
      )
    },
    onSuccess: () => {
      directoryPath
        ? queryClient.invalidateQueries({ queryKey: ['directory-content', org, project, directoryPath] })
        : queryClient.invalidateQueries({ queryKey: ['project-content', org, project] })
    },
  })
}
